import { IconShape } from "@wuilt/section-preview";
import { nanoid } from "nanoid";
function migrateSettings(id, old) {
  // has been migrated before
  if (old.iconStyle) return old;
  const castedOld = old;
  return {
    id: id,
    hidden: false,
    iconStyle: {
      color: "#1d2939",
      shape: IconShape.Filled,
      size: "30"
    },
    socialLinks: Object.keys(castedOld).map(social => ({
      id: `SocialIcon:${nanoid()}`,
      name: social,
      link: castedOld[social]
    }))
  };
}
export function migrateElement(id, old) {
  const settings = migrateSettings(id, old);
  return {
    id: id || `SocialLinks:${nanoid()}`,
    type: "SocialLinks",
    settings
  };
}
//# sourceMappingURL=social-icons-migration.js.map